import type { WizardTileConfig } from '../../types/tileConfig';

const TILE_CONFIGS: WizardTileConfig[] = [
  {
    label: 'offerWizard.stepWhichBusinessCustomerProduct.immoCharging',
    value: 'immoCharging',
    iconComponent: 'BusinessChargingIcon',
    urlValue: 'ImmoCharging',
  },
  {
    label: 'offerWizard.stepWhichBusinessCustomerProduct.coopCharging',
    value: 'coopCharging',
    iconComponent: 'BusinessChargingIcon',
    urlValue: 'CoopCharging',
  },
];

export default TILE_CONFIGS;
